import React from 'react';
import { motion } from 'framer-motion';
import { MdAdd } from 'react-icons/md';

interface DashboardHeaderProps {
  logoImage?: { url: string };
  restaurantName: string;
  firstLetter: string;
  onCreateCampaign: () => void;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  logoImage,
  restaurantName,
  firstLetter,
  onCreateCampaign,
}) => {
  return (
    <div 
      className="flex items-center justify-between mb-4 rounded-[20px] sticky z-10"
      style={{
        top: '3px',
        padding: '10px 20px 10px 20px',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 0 14px 0 rgba(0, 0, 0, 0.1)',
        background: 'linear-gradient(90deg, rgba(33, 33, 33, 0.92), rgba(55, 55, 55, 0.92))',
        opacity: 1,
        border: "1px solid #e0e0e021"
      }}
    >
      <div className="flex items-center gap-4">
        <div className='flex justify-center items-center gap-3'>
          {logoImage ? (
            <img className="w-auto h-10" src={logoImage.url} alt="logo" />
          ) : (
            <div className="w-10 h-10 rounded-full bg-brand-primary flex items-center justify-center text-white font-semibold text-lg">
              {firstLetter}
            </div>
          )}
          <h1 className="text-xl font-medium text-white">
            Welcome Back, <span className="text-brand-primary font-semibold">{restaurantName}</span>!
          </h1>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <motion.button
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onCreateCampaign}
          className="shine-button bg-brand-primary text-white font-medium cursor-pointer py-3 px-5 rounded-full flex items-center gap-2  transition-all"
        >
          <MdAdd size={24} />
          Create Campaign
        </motion.button>
      </div>
    </div>
  );
};
